<template>
  <div class="device-access-container">
    <div class="access-btn" @click="openDeviceDialog">
      <a-icon type="plus" />
      <span>添加设备</span>
    </div>
    <div class="device-list">
      <a-table
        @change="tableChangeEvent"
        :columns="columns"
        :data-source="deviceList"
        :pagination="pagination"
        :row-key="(record, index) => index"
      >
        <span slot="cameraCode" slot-scope="cameraCode, record" @click="copyCode(record)">
          <div class="camera-code">
            <span>{{ cameraCode }}</span>
            <div class="default-tip default-video" v-show="record.defaultVideo">
              默认
              <img src="../../../../assets/img/camera.png" alt="" />
            </div>
            <div class="default-tip default-audio" v-show="record.defaultAudio">
              默认
              <img src="../../../../assets/img/audio.png" alt="" />
            </div>
          </div>
        </span>
        <span slot="accessMode" slot-scope="accessMode">
          {{ handleAccessMode(accessMode) }}
        </span>
        <span slot="supportVideo" slot-scope="supportVideo, record">
          {{ record.supportVideo == 1 && record.supportAudio == 0 ? '视频' : '' }}
          {{ record.supportAudio == 1 && record.supportVideo == 0 ? '音频' : '' }}
          {{ record.supportAudio == 1 && record.supportVideo == 1 ? '视频、音频' : '' }}
          {{ record.supportAudio != 1 && record.supportVideo != 1 ? '--' : '' }}
        </span>
        <span slot="roleType" slot-scope="roleType">
          {{ handleRoleType(roleType) }}
        </span>
        <span slot="deviceStatus" slot-scope="deviceStatus">
          {{ deviceStatus == 0 ? '--' : '已启用' }}
        </span>
        <span slot="action" slot-scope="text, record">
          <div class="action-box">
            <a-icon type="form" @click="handleEditDevice(record)" />
            <a-icon class="delete-device" type="delete" @click="handleDeleteDevice(record)" />
          </div>
        </span>
      </a-table>
    </div>
    <AddDeviceDialog
      ref="deviceDialog"
      :showAddDeviceDialogProp.sync="showAddDeviceDialog"
      :dialogType="dialogType"
      :deviceId="deviceId"
      :classroomCode="classroomInfo.classroomCode"
      @updateDeviceList="getDeviceListData()"
    />
    <DelConfirmDialog
      :showDelDialogProp.sync="showDelDialog"
      delTitle="删除设备"
      tipText="确定要删除此设备吗？"
      @handleDel="handleDel"
    />
  </div>
</template>

<script>
import AddDeviceDialog from './addDeviceDialog.vue'
import DelConfirmDialog from '../../BuildingManagement/components/delDailog.vue'

const columns = [
  {
    title: '设备编号',
    dataIndex: 'cameraCode',
    key: 'cameraCode',
    scopedSlots: { customRender: 'cameraCode' },
    width: 290,
    align: 'left',
    ellipsis: true
  },
  {
    title: '设备名称',
    dataIndex: 'deviceName',
    key: 'deviceName',
    scopedSlots: { customRender: 'deviceName' },
    width: 170,
    ellipsis: true
  },
  {
    title: '接入类型',
    dataIndex: 'accessMode',
    key: 'accessMode',
    scopedSlots: { customRender: 'accessMode' },
    ellipsis: true
  },
  {
    title: '媒体类型',
    dataIndex: 'supportVideo',
    key: 'supportVideo',
    scopedSlots: { customRender: 'supportVideo' },
    ellipsis: true
  },
  {
    title: '机位',
    dataIndex: 'roleType',
    key: 'roleType',
    scopedSlots: { customRender: 'roleType' }
  },
  {
    title: '是否启用',
    dataIndex: 'deviceStatus',
    key: 'deviceStatus',
    scopedSlots: { customRender: 'deviceStatus' }
  },
  {
    title: '操作',
    dataIndex: 'id',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    ellipsis: true,
    class: 'action',
    align: 'center'
    // width: 100,
  }
]

export default {
  props: {
    classroomInfo: {
      type: Object
    }
  },
  components: {
    AddDeviceDialog,
    DelConfirmDialog
  },
  created() {
    this.getDeviceListData()
  },
  data() {
    return {
      columns,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      showAddDeviceDialog: false,
      deviceList: [],
      dialogType: 1,
      deviceId: '',
      showDelDialog: false,
      currentDelId: ''
    }
  },
  methods: {
    tableChangeEvent(pagination) {
      this.pagination.current = pagination.current
      this.getDeviceListData()
    },
    openDeviceDialog() {
      this.dialogType = 1
      this.deviceId = ''
      this.showAddDeviceDialog = true
    },
    handleEditDevice(record) {
      this.dialogType = 2
      this.deviceId = record.id
      this.showAddDeviceDialog = true
    },
    async getDeviceListData() {
      if (!this.classroomInfo.classroomCode) return
      const res = await this.$http.getDeviceList({
        classroomCode: this.classroomInfo.classroomCode,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      })
      if (res.code === 200 && +res.rt.resultStatus === 1) {
        this.deviceList = res.rt.list || []
        this.pagination.total = res.rt.totalCount
      }
    },
    async handleDeleteDevice(record) {
      this.currentDelId = record.id
      this.showDelDialog = true
    },
    async handleDel() {
      const res = await this.$http.deleteDevice({
        id: this.currentDelId
      })
      if (res.code === 200 && res.rt.resultStatus == 1) {
        this.$message.success(res.rt.resultMessage)
        this.showDelDialog = false
        this.pagination.current = 1
        this.getDeviceListData()
      } else if (res.code === 200 && res.rt.resultStatus == -1) {
        this.$message.error(res.rt.resultMessage)
      }
    },
    copyCode(record) {
      this.$copyText(record.cameraCode || ' ').then(
        (e) => {
          this.$message.success('复制成功!')
        },
        (e) => {
          this.$message.error('复制失败!')
        }
      )
    },
    handleAccessMode(mode) {
      let modeArr = mode && mode.split(',')
      let res = []
      if (!modeArr || !modeArr.length) return (res = '--')
      modeArr.map((item) => {
        switch (String(item)) {
          case '1':
            res.push('onvif接入')
            break
          case '2':
            res.push('rtsp/rtmp接入')
            break
          case '3':
            res.push('webrtc接入')
            break
          case '4':
            res.push('手机接入')
            break
          case '5':
            res.push('zrtc拉流方式')
            break

          default:
            res = ['--']
            break
        }
      })
      return res.join(',')
    },
    handleRoleType(role) {
      let roleType = ''
      switch (role) {
        case 1:
          roleType = '老师'
          break
        case 2:
          roleType = '学生'
          break
        case 3:
          roleType = '课件'
          break
        case 0:
          roleType = '未定义'
          break
        default:
          roleType = '--'
          break
      }
      return roleType
    }
  }
}
</script>

<style lang="scss" scoped>
$primary-color: #5f60d3;
.access-btn {
  margin-bottom: 15px;
  width: 108px;
  height: 32px;
  line-height: 30px;
  font-size: 14px;
  border-radius: 2px;
  border: 1px solid $primary-color;
  color: $primary-color;
  cursor: pointer;
}
.delete-device {
  margin-left: 8px;
  font-size: 14px;
}
.camera-code {
  display: flex;
  align-items: center;
  // justify-content: center;
  .default-tip {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin-left: 3px;
    width: 50px;
    height: 20px;
    border-radius: 2px;
    font-size: 12px;
    line-height: 18px;
    img {
      width: 14px;
    }
  }
  .default-video {
    color: #1572ff;
    border: 1px solid #1572ff;
  }
  .default-audio {
    color: #1fcc9c;
    border: 1px solid #1fcc9c;
  }
}
</style>
